import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';
import { checkPermissions } from 'asset-actions-lib/utils/permissions';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AssetActionButtonComponent({
  action,
  uiButtonProps,
  onClick
}) {
  const {
    crmObject,
    nonCrmObject
  } = useAssetActions();
  const {
    scopes,
    gates
  } = useUserInfo();
  const shouldDisplayAction = useMemo(() => checkPermissions({
    permissions: action.displayPermissions,
    scopes,
    gates,
    crmObject,
    nonCrmObject
  }), [action.displayPermissions, crmObject, gates, nonCrmObject, scopes]);
  const shouldEnableAction = useMemo(() => checkPermissions({
    permissions: action && action.enablePermissions,
    scopes,
    gates,
    crmObject,
    nonCrmObject
  }), [action, scopes, gates, crmObject, nonCrmObject]);
  if (!shouldDisplayAction) {
    return null;
  }
  const ButtonComponent = action.ActionButton || Button;
  const DisabledTooltipContent = action.DisabledTooltipContent;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: shouldEnableAction,
    title: DisabledTooltipContent ? /*#__PURE__*/_jsx(DisabledTooltipContent, {
      crmObject: crmObject,
      nonCrmObject: nonCrmObject,
      scopes: scopes,
      gates: gates
    }) : null,
    children: /*#__PURE__*/_jsx(ButtonComponent, Object.assign({
      "data-action": action.id,
      "data-test-id": `action-button-${action.id}`,
      disabled: !shouldEnableAction,
      onClick: () => onClick(action.id)
    }, uiButtonProps, {
      children: action.name || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLib.emptyStates.unnamedAction"
      })
    }))
  });
}